<template>
  <div id="TimeoutModal">
    <div
      class="d-flex flex-row align-items-center justify-content-between heading-row"
    >
      <h1 v-if="!timedOut">Your session is about to expire</h1>
      <h1 v-else>Your session has timed out</h1>
      <div class="ml-auto" v-if="!timedOut">
        <i @click="closeModal()" class="fal fa-times fa-2x"></i>
      </div>
    </div>
    <p class="p-text">
      You’re about to be logged out because of inactivity. If you want to keep your session going, please take action in the next 2 minutes. If not, you’ll be logged out automatically. 
    </p>
    <p class="p-text" v-if="!timedOut">Do you want to stay signed in?</p>
    <div class="d-flex flex-row align-items-center justify-content-end">
      <b-button variant="white" class="" @click="logOut()" squared
        >Sign out now</b-button
      >
      <b-button
        variant="cta"
        class="ml-3"
        @click="closeModal()"
        v-if="!timedOut"
        squared
        >Stay signed in</b-button
      >
    </div>
  </div>
</template>

<script>
import EventBus from "../helpers/eventbus";

const AUTOMATIC_LOGOUT_TIME_IN_MILLISECONDS = 2 * 60 * 1000; // 2 minutes

export default {
  name: "TimeoutModal",
  data() {
    return {
      timedOut: false,
      timeoutId: null
    };
  },
  mounted() {
    let self = this;

    this.timeoutId = setTimeout(() => {
      self.logOut();
    }, AUTOMATIC_LOGOUT_TIME_IN_MILLISECONDS);
  },
  destroyed() {
    clearTimeout(this.timeoutId);

    if (this.timedOut) {
      this.logOut();
    } else {
      EventBus.$emit("timeoutModalClosed");
    }
  },
  methods: {
    async logOut() {
      const sso_id = this.$store.getters.sso_id;
      this.$store.dispatch("logout");
      await this.$msal.initialize();
      const logoutRequest = {
        account: this.$msal.getAccountByHomeId(sso_id),
        postLogoutRedirectUri: "https://" + window.location.hostname + "/login"
      };
      this.$msal.logoutRedirect(logoutRequest);
    },
    closeModal() {
      if (!this.timedOut) {
        clearTimeout(this.timeoutId);
        this.$bvModal.hide("timeout_modal");
        EventBus.$emit("timeoutModalClosed");
      } else {
        this.logOut();
      }
    }
  }
};
</script>
<style lang="less">
#timeout_modal___BV_modal_outer_{
  z-index: 1000001 !important;
}
#TimeoutModal {
  padding: 25px;

  .heading-row {
    padding-bottom: 20px;
  }

  .p-text {
    font-size: 1.4rem;
  }

  .cta-button {
    color: #fff;
    line-height: 1;

    &:hover {
      color: #fff;
    }
  }

  .btn-white {
    background-color: white;
    border: 1px solid grey;

    &:hover {
      background-color: #eee;
    }
  }

  .btn-cta {
    background-color: #00008f;
    border: 1px solid #00008f;
    color: white;

    &:hover {
      background-color: #00008f;
    }
  }

  .fa-times {
    cursor: pointer;
  }
}
</style>
